import qs from 'qs';
import { CasesPayload } from 'types/Request';

let prefixer: string | undefined;

const hostname = window.location.hostname;
const port = window.location.port;

switch (hostname) {
  case import.meta.env.VITE_PRODUCTION_HOST:
    prefixer = import.meta.env.VITE_PRODUCTION_API_URL;
    break;
  case import.meta.env.VITE_STAGING_HOST:
    prefixer = import.meta.env.VITE_STAGING_API_URL;
    break;
  case import.meta.env.VITE_PREPROD_HOST:
    prefixer = import.meta.env.VITE_PREPROD_API_URL;
    break;
  case import.meta.env.VITE_DEV_HOST:
    prefixer = import.meta.env.VITE_DEV_API_URL;
    break;
  default:
    if (port === '3000') prefixer = import.meta.env.VITE_LOCAL_API_URL;
    else prefixer = import.meta.env.VITE_DEV_API_URL;
}

export interface GlobalPaginate {
  page?: number;
  per_page?: number;
  keyword?: string;
}

export const AuthUrls = {
  PASSWORD_LOGIN: `${prefixer}/auth/local`,
  PASSWORD_CHANGE: `${prefixer}/user/change-password`,
  RESET_PASSWORD_INIT: `${prefixer}/user/forgot-password`,
  RESET_PASSWORD: `${prefixer}/user/reset-password`,
  CREATE_PASSWORD: `${prefixer}/user/create-password`,
  REFRESH_TOKEN: `${prefixer}/auth/refresh-token`,
  VERIFY_ACTIVATION_TOKEN: `${prefixer}/auth/verify-activation-token`,
  RESEND_ACTIVATION: `${prefixer}/auth/resend-activation`,
  IMPERSONATE: `${prefixer}/auth/impersonate`,
};

export const UserUrls = {
  GET_CONNECTED_INFO: `${prefixer}/users/me`,
};

export const RequestUrls = {
  CREATE: `${prefixer}/demande/create`,
  RESET_UNREAD_MESSAGE: (caseId: string) =>
    `${prefixer}/demande/reset_case_unread_messages/${caseId}`,
  DOWNLOAD_FILE: `${prefixer}/user/download-file`,
  MESSAGES: (caseId: string) => `${prefixer}/user/cases/${caseId}/messages`,
  SEND_MESSAGE: `${prefixer}/user/send-message`,
  LIST: ({ type, status, keyword }: CasesPayload) =>
    `${prefixer}/user/cases?${qs.stringify(
      { type, status, keyword },
      { arrayFormat: 'comma', skipNulls: true },
    )}`,
};

export const CompteurUrls = {
  GET_DETAILS: (compteurId: string) => `${prefixer}/compteur/${compteurId}`,
  LIST: (
    pageSize?: number,
    page?: number,
    orderBy?: string,
    order?: string,
  ) => {
    let url = `${prefixer}/compteur/list?order=${order}&orderBy=${orderBy}`;

    if (page !== undefined) url += `&page=${page}`;
    if (pageSize !== undefined) url += `&pageSize=${pageSize}`;

    return url;
  },
  LIST_BY_OFFER: `${prefixer}/compteur/list-by-offer`,
};

export const ConsumptionUrls = {
  LIST: (compteurIds: string[]) =>
    `${prefixer}/consumptions?${qs.stringify(
      { compteurIds },
      { arrayFormat: 'comma', skipNulls: true },
    )}`,
};

export const FacturesUrls = {
  LIST: (compteurIds: string[], startDate?: string, endDate?: string) =>
    `${prefixer}/factures?${qs.stringify(
      { compteurIds, startDate, endDate },
      { arrayFormat: 'comma', skipNulls: true },
    )}`,
  DOWNLOAD: `${prefixer}/factures/download`,
};
